import { defineComponent, ref } from 'vue'
import { useRouter } from 'vue-router'
import { Icon } from '@iconify/vue'
import { Button as VanButton, Icon as VanIcon, NavBar as VanNavBar, showToast } from 'vant'
import { useSmartBack } from '@/composables/use-smart-back'
import { useSiteConfigStore } from '@/stores/site-config-store'
import { getApiV1AppDownloadLink } from '@/api/sdk.gen'

// public/ 下的静态文件按站点根路径引用（构建产物里原 import 也只是这个字符串）
const appIcon = '/icon.jpg'

const AppBanner = defineComponent({
  setup() {
    const siteConfigStore = useSiteConfigStore()
    return () => {
      const name = siteConfigStore.siteName
      return (
        <div class="flex flex-col items-center pt-[0.8rem] pb-[0.6rem] px-[0.4rem]">
          {/* APP 图标：优先取后端 site_logo，缺值时回退到本地 icon */}
          <img
            src={siteConfigStore.siteLogo || appIcon}
            class="w-[1.6rem] h-[1.6rem] rounded-[0.32rem] shadow-lg object-cover"
            alt={name}
          />
          {/* 标题 */}
          <p class="text-[0.36rem] font-bold text-[#222] mt-[0.3rem]">{name} APP</p>
        </div>
      )
    }
  },
})

export default defineComponent({
  name: 'DownloadAppPage',
  setup() {
    const router = useRouter()
    const goBack = useSmartBack()
    const androidLoading = ref(false)

    async function downloadApp(platform: 'Android' | 'IOS') {
      androidLoading.value = true
      try {
        const res = await getApiV1AppDownloadLink({ headers: { 'x-platform': platform, 'x-project': 1 } })
        const link = res.data?.data?.download_link
        if (!link) {
          showToast('暂无下载链接，请稍后再试')
          return
        }
        window.open(link, '_blank')
      } finally {
        androidLoading.value = false
      }
    }

    return () => (
      <div class="min-h-screen bg-[#f5f5f5] flex flex-col">
        <VanNavBar title="下载 APP" fixed placeholder onClickLeft={goBack}>
          {{
            left: () => <VanIcon name="arrow-left" color="#333" size="16" />,
          }}
        </VanNavBar>
        <AppBanner />

        <div class="flex-1 px-[0.3rem] flex flex-col gap-[0.24rem]">
          {/* 主下载按钮 */}
          <VanButton
            type="primary"
            block
            loading={androidLoading.value}
            color="#e03131"
            class="!h-[0.88rem] !rounded-[0.16rem] !text-[0.3rem] !font-semibold"
            onClick={() => downloadApp('Android')}
          >
            <div class="flex items-center justify-center gap-[0.12rem]">
              <Icon icon="mdi:download" width="28" height="28" />
              <span>下载 APP</span>
            </div>
          </VanButton>

          {/* 分割线 */}
          <div class="flex items-center gap-[0.2rem] my-[0.04rem]">
            <div class="flex-1 h-px bg-[#ddd]" />
            <span class="text-[0.22rem] text-[#bbb]">选择版本</span>
            <div class="flex-1 h-px bg-[#ddd]" />
          </div>

          {/* iOS 下载 */}
          <VanButton
            block
            class="!h-[0.88rem] !rounded-[0.16rem] !text-[0.28rem] !border-[#ddd] !text-[#333] !bg-white"
            onClick={() => router.push('/ios-install-guide')}
          >
            <div class="flex items-center justify-center gap-[0.12rem]">
              <Icon icon="mdi:apple" width="26" height="26" class="text-[#333]" />
              <span>iOS 版下载</span>
            </div>
          </VanButton>

          {/* Android 下载 */}
          <VanButton
            block
            loading={androidLoading.value}
            class="!h-[0.88rem] !rounded-[0.16rem] !text-[0.28rem] !border-[#ddd] !text-[#333] !bg-white"
            onClick={() => downloadApp('Android')}
          >
            <div class="flex items-center justify-center gap-[0.12rem]">
              <Icon icon="mdi:android" width="26" height="26" class="text-green-600" />
              <span>Android 版下载</span>
            </div>
          </VanButton>
        </div>
      </div>
    )
  },
})
